import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-manage-movein',
    templateUrl: './breadcrumb.manage.movein.component.html'
})

export class BreadcrumbManageMoveinComponent {
    @Input() companyId: number;
    @Input() facilityId: number;
    @Input() kioskId: number;

    roleMatrix: RoleMatrix;


    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
